import { render, staticRenderFns } from "./PaymentsFilters.vue?vue&type=template&id=3db4dc3e&scoped=true"
import script from "./PaymentsFilters.vue?vue&type=script&lang=js"
export * from "./PaymentsFilters.vue?vue&type=script&lang=js"
import style0 from "./PaymentsFilters.vue?vue&type=style&index=0&id=3db4dc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4dc3e",
  null
  
)

export default component.exports